/**
 * Global page title constants and utilities
 */

export const SITE_NAME = "Symbolica";
export const TITLE_SEPARATOR = " – ";

/**
 * Create a page title with the standard format: "Symbolica {pageName}"
 * @param pageName The specific name of the page
 * @returns Formatted page title
 */
export function createPageTitle(pageName: string): string {
  return `${SITE_NAME} ${pageName}`;
}

/**
 * Create a page title with dash separator: "Symbolica – {pageName}"
 * @param pageName The specific name of the page
 * @returns Formatted page title
 */
export function createDashPageTitle(pageName: string): string {
  return `${SITE_NAME}${TITLE_SEPARATOR}${pageName}`;
}

/**
 * Set the document title for client components using "Symbolica {pageName}" format
 * @param pageName The specific name of the page
 */
export function setPageTitle(pageName: string): void {
  if (typeof document !== "undefined") {
    document.title = createPageTitle(pageName);
  }
}

/**
 * Set the document title with dash separator: "Symbolica – {pageName}"
 * @param pageName The specific name of the page
 */
export function setDashPageTitle(pageName: string): void {
  if (typeof document !== "undefined") {
    document.title = createDashPageTitle(pageName);
  }
}

/**
 * Set the document title to just the site name (for home page)
 */
export function setSiteTitle(): void {
  if (typeof document !== "undefined") {
    document.title = SITE_NAME;
  }
}

/**
 * Set a custom page title (for special cases like "Agentica by Symbolica")
 * @param title The full title to set
 */
export function setCustomPageTitle(title: string): void {
  if (typeof document !== "undefined") {
    document.title = title;
  }
}
